module.exports = __webpack_public_path__ + "static/media/ic_分配模板.0ebf53b4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_分配模板.svg
// module id = 366
// module chunks = 0